import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HeaderService } from 'src/_lib/service/header.service';
import { AppConstants } from 'src/app/app.constants';
import { environment } from 'src/environments/environment.prod';
import { DynamicThemeClassService } from 'src/_lib/service/dynamic-theme-class.service';
import { HeaderCascadingLinkComponent } from './header-cascading-link/header-cascading-link.component';
import { SearchByVehicleComponent } from 'src/app/templates/search-by-vehicle/search-by-vehicle.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-header-third-row',
  templateUrl: './header-third-row.component.html',
  styleUrls: ['./header-third-row.component.scss'],
  standalone: true,
  imports: [NgFor, RouterLink, NgIf, NgClass, HeaderCascadingLinkComponent],
})
export class HeaderThirdRowComponent {
  firstObj: number = this.appConstants.firstObj;
  headerdata: any[];
  chTheme7 = environment.chTheme7;

  constructor(
    private headerHttp: HeaderService,
    private appConstants: AppConstants,
    public dialog: MatDialog,
    private dynamicThemeClassService: DynamicThemeClassService,
  ) {}
  themeClass(divName: string): string {
    return this.dynamicThemeClassService.generateClassName(divName);
  }

  ngOnInit(): void {
    this.getheaderList();
  }

  getheaderList(): void {
    this.headerHttp.headerList().subscribe((data) => {
      this.headerdata = data[this.firstObj]?.data?.thirdRow;
    });
  }

  getFlip(categories: any[], index: number) {
    const depth = this.getMaxDepth(categories);
    if (index > 5) {
      return true;
    } else if (index > 4 && depth > 2) {
      return true;
    } else if (index > 3 && depth > 3) {
      return true;
    } else {
      return false;
    }
  }

  getMaxDepth(categories: any[], depth = 1): number {
    let maxDepth = depth;
    for (const category of categories) {
      if (category.category_children?.length) {
        maxDepth = Math.max(
          maxDepth,
          this.getMaxDepth(category.category_children, depth + 1),
        );
      }
    }
    return maxDepth;
  }

  openVechiclePopup(): void {
    this.dialog.open(SearchByVehicleComponent, {
      width: '600px',
      panelClass: 'search-by-vehicle-dialog'
    });
  }
}
